/**
 * ⚙️ 営業・通知設定 Hub (v3.3 IA 刷新)
 *
 * 旧 SalesSettingsPage の 7 内部タブを Hub レベルに昇格。
 * 2026-10-26: 「自動メール」→「自動通知」に改名し、「フォーム通知」を統合。
 * 全タブで featureId = 'sales.settings' を共有 (旧来通り単一権限で統括)。
 *
 * 余白 / スクロール統一: 外側 Screen は使わず、各タブの render で Screen
 * ラップして screen-body を scrollable container にする。
 */
import { AutoNotifyTab } from './tabs/AutoNotifyTab';
import { CategoriesTab } from './tabs/CategoriesTab';
import { ConsentTab } from './tabs/ConsentTab';
import { DocumentDeadlineTab } from './tabs/DocumentDeadlineTab';
import { MailTemplatesTab } from './tabs/MailTemplatesTab';
import { SaCycleTab } from './tabs/SaCycleTab';

import { HubTabs, type TabSpec } from '@/components/layout/HubTabs';
import { Screen } from '@/components/layout/Screen';

const TABS: TabSpec[] = [
  {
    tabKey: 'deadline',
    label: '書類期限',
    featureId: 'sales.settings',
    render: () => (
      <Screen title="書類期限" description="見積・請求書の有効期限デフォルトを管理">
        <DocumentDeadlineTab />
      </Screen>
    ),
  },
  {
    // 2026-10-26: 「自動メール」を「自動通知」に改名し、「フォーム通知」タブを統合。
    // URL の互換のため tabKey は 'auto-mail' のまま。
    tabKey: 'auto-mail',
    label: '自動通知',
    featureId: 'sales.settings',
    render: () => (
      <Screen
        title="自動通知"
        description="自動メールの送信元、経理担当への通知 (メール / Google Chat / Chatwork)、返答待ち回答の通知先を設定"
      >
        <AutoNotifyTab />
      </Screen>
    ),
  },
  {
    tabKey: 'mail-templates',
    label: '業務通知',
    featureId: 'sales.settings',
    render: () => (
      <Screen
        title="業務通知テンプレート"
        description="見積送付・失注通知・報酬支払等の自動送信メール雛形"
      >
        <MailTemplatesTab />
      </Screen>
    ),
  },
  {
    tabKey: 'categories',
    label: 'カテゴリー',
    featureId: 'sales.settings',
    render: () => (
      <Screen title="カテゴリー管理" description="商品カテゴリーと表示順を管理">
        <CategoriesTab />
      </Screen>
    ),
  },
  {
    tabKey: 'sa-cycle',
    label: '販売代理店',
    featureId: 'sales.settings',
    render: () => (
      <Screen title="販売代理店サイクル" description="販売代理店の報酬計算サイクル設定">
        <SaCycleTab />
      </Screen>
    ),
  },
  {
    tabKey: 'consent',
    label: '同意書',
    featureId: 'sales.settings',
    render: () => (
      <Screen title="同意書編集" description="購入・取引時に表示される同意書テキストを編集">
        <ConsentTab />
      </Screen>
    ),
  },
];

export function SalesConfigHubPage() {
  return <HubTabs tabs={TABS} defaultTab="deadline" />;
}
